import React from "react";
import { useTranslation } from "react-i18next";
import JsonData from "../../data/data.json";

export function LegalContentRenderer({ sections }) {
  const { i18n } = useTranslation();
  const lang = String(i18n.language || "pt").slice(0, 2);
  const contact = JsonData?.Contact || {};
  const about = JsonData?.About || {};

  const vars = {
    nameBank: about.nameBank || contact.nameBank || "Proseg Pay",
    nameBank2: about.nameBank2 || contact.nameBank2 || "Proseg Pay",
    nameDomain: about.nameBankDomain || contact.nameBankDomain || "prosegpay",
    bankDomain: about.nameBankDomain || contact.nameBankDomain || "prosegpay",
    brand: about.nameBank || contact.nameBank || "Proseg Pay",
    cnpj: contact.line1?.cnpj || "",
    address: contact.line1?.address || "",
    complement: contact.line1?.complemento || "",
    district: contact.line1?.bairro || "",
    city: contact.line1?.city || "",
    zip: contact.line1?.cep || "",
    email: contact.email || "",
  };

  // "{{address}}, {{district}}, {{city}}, CEP {{zip}}" vira uma linha única,
  // sem vírgulas órfãs quando data.json ainda não tem o endereço.
  const addressParts = [vars.address, vars.complement, vars.district, vars.city].filter(Boolean);
  const hasAddress = addressParts.length > 0 || Boolean(vars.zip);
  const ADDRESS_PLACEHOLDER = {
    CEP: "[endereço a definir]",
    ZIP: "[address to be defined]",
    CP: "[dirección por definir]",
  };

  const interpolate = (text) => {
    const prepared = String(text).replace(
      /\{\{address\}\},\s*\{\{district\}\},\s*\{\{city\}\},\s*([A-Za-z.]+)\s*\{\{zip\}\}/g,
      (_, label) => {
        if (!hasAddress) {
          const byLang = { pt: "CEP", en: "ZIP", es: "CP" };
          return ADDRESS_PLACEHOLDER[byLang[lang]] || ADDRESS_PLACEHOLDER.CEP;
        }
        return addressParts.join(", ") + (vars.zip ? `, ${label} ${vars.zip}` : "");
      }
    );
    return prepared.replace(/\{\{(\w+)\}\}/g, (_, key) => {
      const value = vars[key];
      return value != null ? String(value) : `{{${key}}}`;
    });
  };

  if (!Array.isArray(sections)) return null;

  return (
    <div id="bodyContrato" className="inner-page__card inner-page__prose text-just">
      {sections.map((section, index) => {
        if (section.type === "heading") {
          const Tag = `h${section.level || 5}`;
          return React.createElement(Tag, { key: index }, interpolate(section.text));
        }

        if (section.type === "list") {
          return (
            <ul key={index}>
              {section.items.map((item, itemIndex) => (
                <li key={itemIndex} dangerouslySetInnerHTML={{ __html: interpolate(item) }} />
              ))}
            </ul>
          );
        }

        if (section.type === "html") {
          return (
            <p
              key={index}
              dangerouslySetInnerHTML={{ __html: interpolate(section.text) }}
            />
          );
        }

        return <p key={index}>{interpolate(section.text)}</p>;
      })}
    </div>
  );
}

export function useLegalSections(namespace) {
  const { t } = useTranslation(namespace);
  return t("sections", { returnObjects: true });
}
